<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show" :title="title" size="sm" modal-class="mobile-full-screen"
                   @hidden="hideModal" @ok.prevent="handleSubmit(onExportAllImagesClick)">
      <div class="col-md-12">
        <lot-export-images-name-templates-widget :model="model" attribute="filename_templates" type="text" :items="fileNameTemplates"/>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>
<script>
import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
import {createNamespacedHelpers} from "vuex";
import SubmitButton from "@/core/components/common/SubmitButton";
import CancelButton from "@/core/components/common/CancelButton";
import LotsService from "@/modules/lots/LotsService";
import InventoryService from "@/modules/inventory/InventoryService";
import LotExportImagesNameTemplatesWidget from "@/core/widgets/LotExportImagesNameTemplatesWidget.vue";
import LotExportImagesTemplateModel from "@/modules/lots/models/LotExportImagesTemplate.model";
import i18n from "@/shared/i18n";

const {mapActions, mapState} = createNamespacedHelpers('lots');
const {mapActions: mapSalesActions} = createNamespacedHelpers('sales');
const {mapState: globalMapState} = createNamespacedHelpers('global');

export default {
  name: "LotExportImagesTemplatesModal",
  components: {LotExportImagesNameTemplatesWidget, CancelButton, SubmitButton, ArtisioModal},
  data() {
    return {
      model: new LotExportImagesTemplateModel()
    }
  },
  computed: {
    ...mapState({
      modal: state => state.lotExportImagesTemplateModal,
      sale: state => state.lotExportImagesTemplateModal.sale,
    }),
    ...globalMapState({
      currentUser: state => state.currentUser,
      fileNameTemplates: state => state.auctionImageExportNamingFormat,
    }),
    title() {
      return this.$i18n.t('Select filename template');
    },
  },
  methods: {
    ...mapActions(['hideLotImagesNameModal']),
    ...mapSalesActions(['getSale']),
    hideModal() {
      this.hideLotImagesNameModal();
      this.model = new LotExportImagesTemplateModel();
    },
    onExportAllImagesClick() {
        if (this.modal.mode === 'selected') {
          this.onExportSelectedImagesClick();
          return;
        }
        if (this.modal.mode === 'inventory') {
          this.onExportInventoryImagesClick();
          return;
        }
        const template = {"file_name_template": this.model.filename_templates}
        let extraMessage
        let msg = this.$i18n.t("Export may take time, depending on the size of the data. Are you sure you want to proceed?") + '<br/> <br/>'
        if (!this.sale.is_images_exported) {
          msg += this.$i18n.t("Please click the 'Generate Image Exports' button to create download links for the images.");
        } else {
          msg += this.$i18n.t("Already generated at {date} by {author}", {date: this.$options.filters.toDateTime(this.sale.auction_images_export.created_at), author: this.sale.auction_images_export.created_by.display_name});
          extraMessage = '<div class="hover-cursor hover-underline text-primary">' + this.$i18n.t("Download") + '</div>'
        }
        this.$confirm(
          msg,
          this.$i18n.t("Image export links are being generated please check back soon."),
          (event) => {
            return LotsService.getLotsImagesZipData(event).then(() => this.getSale(this.sale.uuid))
          },
          {template, auctionUuid: this.sale.uuid},
          i18n.t('Please Confirm'),
          this.sale.is_images_exported ? 'Regenerate Image Export' : 'Generate Image Exports',
          i18n.t("Cancel"),
          null,
          null,
          extraMessage && {
            message: extraMessage,
            handler: LotsService.getLotsImagesZipData,
            handlerParams: {template: {is_reexport: true}, auctionUuid: this.sale.uuid},
            successMessage: this.$i18n.t("Image export links are being generated please check back soon.")
          }
        );
        this.hideModal();
      },
      onExportInventoryImagesClick() {
        const inventory_uuids = this.modal.inventory_uuids || [];
        const count = this.modal.inventory_count || inventory_uuids.length;
        const file_name_template = this.model.filename_templates;
        const msg = this.$i18n.t(
          "Export may take time, depending on the size of the data. You are about to export images for {count} selected inventory item(s). Are you sure you want to proceed?",
          {count}
        );
        this.$confirm(
          msg,
          this.$i18n.t("Image export links are being generated please check back soon."),
          (event) => InventoryService.batchDownloadImages(event),
          {inventory_uuids, file_name_template},
          i18n.t('Please Confirm'),
          i18n.t('Generate Image Exports'),
          i18n.t("Cancel"),
        );
        this.hideModal();
      },
      onExportSelectedImagesClick() {
        const lot_uuids = this.modal.lot_uuids || [];
        const count = this.modal.lot_count || lot_uuids.length;
        const template = {
          file_name_template: this.model.filename_templates,
          lot_uuids,
        };
        const msg = this.$i18n.t(
          "Export may take time, depending on the size of the data. You are about to export images for {count} selected lot(s). Are you sure you want to proceed?",
          {count}
        );
        this.$confirm(
          msg,
          this.$i18n.t("Image export links are being generated please check back soon."),
          (event) => LotsService.getLotsImagesZipData(event),
          {template, auctionUuid: this.sale.uuid},
          i18n.t('Please Confirm'),
          i18n.t('Generate Image Exports'),
          i18n.t("Cancel"),
        );
        this.hideModal();
      },
  }
}
</script>

<style scoped>
</style>
